import React, { useEffect, useState } from "react";
import "./AllSubjectsCategory.scss";
import { Link } from "react-router-dom";
const Hashtags = ({reletedSubjects}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const displayedContent = isExpanded
    ? reletedSubjects
    : reletedSubjects?.slice(0, 30);

  return (
    <div className="subject-tabs-div overflow-x-hidden">
      <div className="row">
        <div id="tab-content" className="tabcontent">
          <div className="subject-tabs">
            <ul className="d-flex justify-content-start flex-wrap p-0">
              {displayedContent && displayedContent?.length > 0 && displayedContent.map((subject, index) => (
                <li key={index}>
                  <Link to={`/${subject?.subjectId?.subjectUrl}/${subject.subSubjectUrl}`} style={{border:"2px solid #8886c9",background:"none"}}>
                    {subject?.subSubjectName}
                  </Link>
                </li>
              ))}
            </ul>
            <button
              onClick={handleToggle}
              className="rbt-btn btn-gradient btn-sm mt-4"
            >
              {isExpanded ? "Show Less" : "Show More"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hashtags;
